import { createSlice } from "@reduxjs/toolkit";

const initialState = { state: [] };
export const usersCompanyAccessDetailsSlice = createSlice({
  name: "companyAccess",
  initialState,
  reducers: {
    setCompanyAccessDetail: (state, action) => {
      state.state = action.payload;
    },
  },
});

export const { setCompanyAccessDetail } =
  usersCompanyAccessDetailsSlice.actions;
export default usersCompanyAccessDetailsSlice.reducer;
